module.exports = __webpack_public_path__ + "static/dbLogo.aeb6ea0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dbLogo.png
// module id = 304
// module chunks = 114276838955818